<template>
  <div style="background: #212226; margin-bottom: 10px">
    <p class="goldenP">
      <img
        src="@/assets/wallet.svg"
        style="
          width: 20px;
          margin-right: 12px;
          margin-left: 12px;
          margin-bottom: 2px;
        "
        alt=""
      />{{ $t("LanguageEn.balance") }}:
      {{ balance | transliterate(cookiesObject.lang) }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Balance",
  data() {
    return {
      cookiesObject: "",
    };
  },
  async created() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;
  },
  components: {},
  props: {},
  methods: {},
  computed: {
    ...mapGetters(["httpReq", "balance"]),
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #e6e6e6;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  padding-left: 10px;
}
.pop1 {
  animation: color-change 1.2s infinite;
}

.perf {
  border-right: 3px solid #fab244;
}
.w {
  border-right: 3px solid #419b45;
}

.l {
  border-right: 3px solid #cb4757;
}
.nd {
  border-right: 3px solid #4f4f51;
}
</style>
